import { SOCKET_EVENT } from '@/shared/api';
import type { ISocketService, MessageData } from '@/shared/api';

/**
 * MSW 모킹 전용 SocketService.
 * Next dev 서버의 WebSocket과 MSW ws interceptor가 충돌할 수 있어
 * 네트워크 연결 없이 메모리 이벤트 버스로 서버발 이벤트를 흉내낸다.
 */
export class MockSocketService implements ISocketService {
  private _isConnected = false;
  private _listeners = new Map<string, Set<(data: unknown) => void>>();
  private static instance: MockSocketService;
  private constructor() {}

  public static getInstance(): MockSocketService {
    if (!MockSocketService.instance) {
      MockSocketService.instance = new MockSocketService();
    }
    return MockSocketService.instance;
  }

  public static emit(eventName: string, data?: unknown): void {
    MockSocketService.getInstance().executeCallback(eventName, data);
  }

  public initialize(): void {
    // No-op: mock mode does not create a real socket connection.
  }

  public isConnected(): boolean {
    return this._isConnected;
  }

  private executeCallback(eventName: string, data: unknown): void {
    this._listeners.get(eventName)?.forEach((cb) => cb(data));
  }

  public on(eventName: string, callback: (data: unknown) => void): void {
    if (!this._listeners.has(eventName)) {
      this._listeners.set(eventName, new Set());
    }
    this._listeners.get(eventName)!.add(callback);

    if (eventName === SOCKET_EVENT.CONNECT && this._isConnected) {
      callback(undefined);
    }
  }

  public off(eventName: string, callback: (data: unknown) => void): void {
    this._listeners.get(eventName)?.delete(callback);
  }

  public connectSocket(): void {
    if (this._isConnected) return;

    this._isConnected = true;
    this.executeCallback(SOCKET_EVENT.CONNECT, undefined);
  }

  public disconnectSocket(): void {
    if (!this._isConnected) return;

    this._isConnected = false;
    this.executeCallback(SOCKET_EVENT.DISCONNECT, undefined);
  }

  public send(event: string, data?: MessageData, callback?: () => void): void {
    if (!this._isConnected) {
      console.warn('Socket not connected. Message dropped:', event, data);
      return;
    }

    if (callback && data?.uid) {
      callback();
    }
  }
}
